export default "__VITE_ASSET__BYFAvHKB__"